import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          {aboutData.title}
        </h2>

        <div className="rounded-2xl bg-background-100 border border-background-200 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-[700px] mx-auto mb-10">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500 whitespace-nowrap">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}